<ion-header>
  <ion-toolbar>
    <ion-title [innerHTML]="scenario?.name || ('SCENARIOS.ADD_SCENARIO' | translate)"></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [formGroup]="form">
  <ion-item>
    <ion-label position="stacked" [innerHTML]="'SCENARIOS.TITLE' | translate"></ion-label>
    <ion-input type="text" formControlName="name"></ion-input>
  </ion-item>

  <ion-item>
    <ion-label position="stacked" [innerHTML]="'SCENARIOS.DESCRIPTION' | translate"></ion-label>
    <ion-textarea formControlName="description" [autoGrow]="true"></ion-textarea>
  </ion-item>

  <div class="item" *ngIf="!shouldHideTriggerSelector">
    <ion-label position="stacked" [innerHTML]="'SCENARIOS.TRIGGERED_BY' | translate"></ion-label>
    <ng-select
      class="autocomplete"
      formControlName="triggerId"
      bindLabel="name"
      bindValue="id"
      groupBy="type"
      [items]="triggers$ | async | translateTriggerNames"
    ></ng-select>
  </div>

  <ion-item lines="none">
    <ion-label position="stacked" [innerHTML]="'SCENARIOS.QUERY' | translate"></ion-label>
    <ion-textarea class="--query" formControlName="query" [autoGrow]="true"></ion-textarea>
  </ion-item>

  <ion-item>
    <ion-label position="stacked" [innerHTML]="'SCENARIOS.TARGET_VALUE' | translate"></ion-label>
    <div class="wrap">
      <ion-select class="--operator" formControlName="operator">
        <ion-select-option *ngFor="let operator of operators" [value]="operator" [innerHTML]="operator"></ion-select-option>
      </ion-select>
      <ion-input type="number" inputmode="numeric" formControlName="targetValue"></ion-input>
    </div>
  </ion-item>

  <ion-item lines="none">
    <ion-label position="stacked" [innerHTML]="'SCENARIOS.ACTIVE' | translate"></ion-label>
    <ion-toggle formControlName="active"></ion-toggle>
  </ion-item>
</ion-content>

<ion-footer>
  <ion-button
    class="button --small --primary-outline"
    *ngIf="scenario"
    [innerHTML]="'BUTTONS.DELETE' | translate"
    (click)="remove()"
  ></ion-button>
  <ion-button class="button --small --dark-outline" [innerHTML]="'BUTTONS.CANCEL' | translate" (click)="dismiss()"></ion-button>
  <ion-button
    class="button --small --success"
    [disabled]="form.invalid || (loading$ | async)"
    [innerHTML]="'BUTTONS.SAVE' | translate"
    (click)="save()"
  ></ion-button>
</ion-footer>
